const faqQuestions = document.querySelectorAll(".faq-section__question");

    faqQuestions.forEach((question) => {
      question.addEventListener("click", () => {
        const item = question.closest(".faq-section__item");
        const isOpen = item.classList.contains("is-open");

        faqQuestions.forEach((q) => {
          q.closest(".faq-section__item").classList.remove("is-open");
          q.setAttribute("aria-expanded", "false");
          const icon = q.querySelector(".faq-section__plus");
          if (icon) icon.textContent = "+";
        });

        if (!isOpen) {
          item.classList.add("is-open");
          question.setAttribute("aria-expanded", "true");
          const icon = question.querySelector(".faq-section__plus");
          if (icon) icon.textContent = "-";
        }
      });
    });